import React from "react";

const Profilemodal=({member, onClose})=>{

    if(!member)
        return null

    return(
        <div className="fixed inset-0 bg-black  bg-opacity-10 backdrop-blur-lg flex items-center  justify-center z-50 transition-all duration-300 ease-in-out" onClick={onClose}>
            <div className="bg-white rounded-xl p-6 text-center md:w-[380px] md:h-fit w-full relative md:top-[-210px] lg:top-[40px] ">
                <img src={member.img}
                alt={member.name}
                className="w-80 h-90 rounded mx-auto"/>
                <h2 className="text-xl font-bold mt-4 uppercase">{member.name}</h2>
                <p className="text-blue-600 uppercase">{member.Designation}</p>

                <button className="absolute top-2 right-3 text-gray-500 text-xl" onClick={onClose}>&times;</button>
            </div>
        </div>
    )
}

export default Profilemodal;